import { render, staticRenderFns } from "./CreateNomenclatureRental.vue?vue&type=template&id=1b2a0068&scoped=true"
import script from "./CreateNomenclatureRental.vue?vue&type=script&lang=js"
export * from "./CreateNomenclatureRental.vue?vue&type=script&lang=js"
import style0 from "./CreateNomenclatureRental.vue?vue&type=style&index=0&id=1b2a0068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a0068",
  null
  
)

export default component.exports